import React from 'react';

import i18next from 'i18next';

import Alerts from '../../../components/Alerts';
import Documents from '../../../components/Documents';
import Products from '../../../components/Products';

/**
 * Genera las pestañas estándar para la configuración de productos financieros
 * @param {Object} ParametersComponent - Componente de parámetros específico del partner
 * @param {Object} config - Configuración adicional de tabs
 * @returns {Function} Función que retorna las tabs
 */
export const createTabsBuilder =
    (ParametersComponent, config = {}) =>
    ({
        control,
        disabled,
        financierType,
        getValues,
        initialValues,
        setValue,
        typeAlgorithm,
    }) => {
        const baseTabs = [
            {
                component: (
                    <ParametersComponent
                        control={control}
                        disabled={disabled}
                        setValue={setValue}
                    />
                ),
                id: 'tab-parameters',
                label: i18next.t('Parameters'),
                value: 'parameters',
            },
            {
                component: (
                    <Products
                        control={control}
                        disabled={disabled}
                        initialValues={initialValues}
                        setValue={setValue}
                    />
                ),
                id: 'tab-products',
                label: i18next.t('Product', { count: 2 }),
                value: 'products',
            },
            {
                component: (
                    <Documents
                        control={control}
                        disabled={disabled}
                        financierType={financierType}
                    />
                ),
                id: 'tab-documents',
                label: i18next.t('Document', { count: 2 }),
                value: 'documents',
            },
            {
                component: (
                    <Alerts
                        control={control}
                        disabled={disabled}
                        setValue={setValue}
                    />
                ),
                id: 'tab-alerts',
                label: i18next.t('Rules'),
                value: 'alerts',
            },
        ];

        // Permitir agregar tabs adicionales del partner
        if (config.additionalTabs) {
            return [
                ...baseTabs,
                ...config.additionalTabs({
                    control,
                    disabled,
                    getValues,
                    setValue,
                    typeAlgorithm,
                }),
            ];
        }

        return baseTabs;
    };
